function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#FFBE54;stroke:#000000;stroke-miterlimit:10;}\n\t.st1{fill:#37BEB7;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M25.3,13v11c0,0.8-0.1,1.6-0.5,2.3c-0.6,1.1-1.5,1.9-2.7,2.2c-0.7,0.2-1.4,0.3-2.1,0.3c-1.8,0.1-3.4-1.2-3.8-3 c-0.3-1.5,0.4-3.1,2-3.9c0.6-0.3,1.3-0.5,2-0.6c0.7-0.2,1.5-0.3,2.2-0.5c0.5-0.1,0.9-0.4,1-1c0-0.1,0-0.2,0-0.4c0-3.5,0-7,0-10.5 c0-0.1,0-0.2-0.1-0.4c-0.1-0.3-0.3-0.5-0.6-0.5c-0.3,0-0.6,0.1-0.9,0.1C20.5,8.7,19,9,17.6,9.3l-7.1,1.4c0,0-0.1,0-0.1,0 c-0.5,0.2-0.7,0.4-0.7,1c0,0.1,0,0.2,0,0.2c0,5,0,10.1,0,15.1c0,0.8-0.1,1.6-0.4,2.4c-0.5,1.2-1.5,2-2.8,2.4C5.7,32,5,32.1,4.3,32.1 c-1.8,0.1-3.4-1.2-3.7-3c-0.3-1.6,0.4-3.3,2.2-4c0.7-0.3,1.4-0.4,2.1-0.6c0.6-0.1,1.1-0.2,1.7-0.3c0.7-0.2,1.1-0.6,1.2-1.4v-0.3 c0-5.7,0-11.4,0-17.2c0-0.2,0-0.5,0.1-0.7c0.1-0.6,0.5-0.9,1.1-1c0.5-0.1,1-0.2,1.5-0.3c1.4-0.3,2.8-0.6,4.3-0.9L19,1.6 c1.3-0.3,2.6-0.5,3.9-0.8c0.4-0.1,0.9-0.2,1.3-0.2c0.6-0.1,1,0.3,1.1,0.9c0,0.1,0,0.3,0,0.4C25.3,5.6,25.3,9.3,25.3,13L25.3,13z"
});

var _ref4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 27,
  cy: 27,
  r: 4.8
}), /*#__PURE__*/React.createElement("polygon", {
  points: "27.6,26.4 27.6,24 26.4,24 26.4,26.4 24,26.4 24,27.6 26.4,27.6 26.4,30 27.6,30 27.6,27.6 30,27.6 30,26.4  "
}));

var SvgAddMusic = function SvgAddMusic(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Laag_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32.9 32.8",
    style: {
      enableBackground: "new 0 0 32.9 32.8"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAddMusic, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/AddMusic.61912f03.svg";
export { ForwardRef as ReactComponent };